import moment, { Moment } from 'moment';

export const getDiff = (value: Moment): number =>
  value.startOf('day').diff(moment().startOf('day').format(), 'day');
